export default `
    <div id="#= data.id #_cid" class=" #= data.containerClasses # # if (data.disabled || data.readOnly || data.readonly) { # disabled # } #">
        <label class="checkbox-wrapper col-xs-12 no-pad">
            # if (data.isPaneField) { #
                <div class="pane-field-label col-xs-5">
                    <input id="#= data.id #" type="checkbox" # if (data.disabled || data.readOnly || data.readonly) { # disabled # } # class="checkbox-input bind-value #= data.bindClasses || data.classes || ""#" 
                        # if (data.bindValue) { # data-bind="checked: #= data.bindValue #" # } #/>
                    <span for="#= data.id #" class="checkbox-container #= data.checkboxClasses || "" # right">
                        <span class="checkbox-check">
                        </span>
                    </span>
                </div>
            # } else { #
                <input id="#= data.id #" type="checkbox" # if (data.disabled || data.readOnly || data.readonly) { # disabled # } # class="checkbox-input bind-value #= data.bindClasses || data.classes || ""#" 
                    # if (data.bindValue) { # data-bind="checked: #= data.bindValue #" # } #/>
                <span for="#= data.id #" class="checkbox-container #= data.checkboxClasses || "" #">
                    <span class="checkbox-check">
                    </span>
                </span>
            # } #
            <span id="#= data.id#_label" class="checkbox-label bind-label #= data.labelClasses || ""# #= data.isPaneField ? "col-xs-7 no-pad" : "checkbox-label-width" #" # if (data.title) { # data-bind="text: #= data.title #" title="#: z.ll(data.title) #" # } # data-label-for-id="#= data.id #">
                #=data.hcLabel || data.hcLabelAbove || ""## if (data.cf && !data.hideSS) { #<span class="checkbox-cf" title="#= z.ll("CustomFieldLabelTitle", true) #">C</span># } #
            </span>
            # if (data.countBind) { #
                <span class="checkbox-label">
                    <span class="bind-value" data-bind="countText: #= data.countBind #">
                    </span>
                </span>
            # } #
        </label>
    </div>
`;
